import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { GetExtensionDetail_extension_extensionPagingGroup } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-paging-group-detail-left-column',
    styleUrls: ['./extension-paging-group-detail-left-column.component.scss', '../extension-detail-view.component.scss'],
    templateUrl: './extension-paging-group-detail-left-column.component.html',
    standalone: false
})
export class ExtensionPagingGroupDetailLeftColumnComponent {
   @Input() extensionPagingGroup: GetExtensionDetail_extension_extensionPagingGroup | null;

   hasAnyMembers(): boolean {
      return !!(
         this.extensionPagingGroup?.pagingGroupMembersConnection?.items?.length ||
         this.extensionPagingGroup?.pagingGroupExtensionGroupsConnection?.items?.length
      );
   }
}
